module.exports = __webpack_public_path__ + "img/VolumeHighOff.f692f789.png";